import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router, NavigationEnd } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
@Component({
  selector: 'app-vj-main-nav-bar',
  templateUrl: './vj-main-nav-bar.component.html',
  styleUrls: ['./vj-main-nav-bar.component.css']
})
export class VjMainNavBarComponent implements OnInit {

  tieredItems: MenuItem[] = [];
  hubMenu: MenuItem[] = [];
  ABRMenu: MenuItem[] = [];
  sfdcMenu: MenuItem[] = [];
  pidJobs: MenuItem[] = [];
  vjMarketing: MenuItem[] = [];
  admin: MenuItem[] = [];
  authUserClaims: any;
  @ViewChild('topbarmenu') menu!: ElementRef;
  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  constructor(private router:  Router, private authenticationService:AuthenticationService, private jwtHelper: JwtHelperService) {
    router.events.subscribe( (event) => ( event instanceof NavigationEnd ) && this.handleRouteChange() )
  }

  ngOnInit(): void {
    this.getJWTClaims();
    this.pidJobs = [
      {
        label: '',
        icon: 'pi pi-fw pi-th-large',
        routerLink: '/',
      },
      {
        label: 'New',
        icon: 'fa fa-fw fa-plus',
        routerLink: '/pqi-jobs/new-job',
      },
      {
        label: 'Jobs',
        icon: 'pi pi-fw pi-verified',
        routerLink: '/pqi-jobs/vJobs',
      },

      {
        label: 'Configurations',
        icon: 'fa fa-fw fa-cogs',
        items: [
          {
            label: 'Manage Opco',
            icon: 'pi pi-fw pi-list',
            routerLink: '/global/vOpco',
          },
          {
            routerLink: '/global/vEntities',
            label: 'Manage Entities',
            icon: 'pi pi-fw pi-list',
          },
          {
            routerLink: '/global/vUsers',
            label: 'Manage Associates',
            icon: 'pi pi-fw pi-list',
          },
          {
            routerLink: '/global/email',
            label: 'Email Templates',
            icon: 'pi pi-fw pi-list',
          },
          {
            routerLink: '/pqi-jobs/vTaskTypes',
            label: 'Settings',
            icon: 'pi pi-fw pi-list',
          },
        ],
      },

      {
        label: 'Signout',
        icon: 'pi pi-fw pi-sign-out',
        command: () => this.logout(),
      },
    ];


    this.ABRMenu = [
      {
        label: '',
        icon: 'pi pi-fw pi-th-large',
        routerLink: '/',
      },
      {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-home',
        routerLink: 'pqi-abr/dashboard',
      },
      {
        label: 'Annual Business Review',
        icon: 'pi pi-fw pi-briefcase',
        routerLink: '',
        items: [
          {
            label: 'AB Review',
            icon: 'pi pi-fw pi-list',
            routerLink: '/pqi-abr/abr-profiles-list',
          },
          
        ],

      },
    
      // {
      //   label: 'Reports',
      //   icon: 'pi pi-fw pi-database',
      //   routerLink: '',

      // },
      { separator: true },
      {
        label: '',
        icon: 'pi pi-fw pi-sign-out',
        command: () => this.logout(),
      },
    ];

    this.hubMenu = [
        {
          label: '',
          icon: 'pi pi-fw pi-th-large',
          routerLink: '/',
        },
        {
          label: 'Dashboard',
          icon: 'pi pi-fw pi-home',
          routerLink: 'pqi-hub/dashboard',
        },
  
        {
          label: '3P Profiles',
          icon: 'pi pi-fw pi-briefcase',
          routerLink: '',
          items: [
            {
              label: '3P Profiles',
              icon: 'pi pi-fw pi-folder',
              routerLink: '/pqi-hub/third-party-profiles',
    
            },
            {
              label: 'Case Folders',
              icon: 'pi pi-fw pi-folder',
              routerLink: '/pqi-hub/case-folders',
    
            },
            
            
          ],

        },
        {
          label: 'Reports',
          icon: 'pi pi-fw pi-briefcase',
          routerLink: '',
          items: [
            {
              label: 'AB Review Report',
              icon: 'pi pi-fw pi-list',
              routerLink: '/pqi-hub/abr-review-report',
            },
            {
              label: 'AB CrossOver Report',
              icon: 'pi pi-fw pi-list',
              routerLink: '/pqi-hub/abr-crossOver-report',
            },
            {
              label: 'Compliance Report',
              icon: 'pi pi-fw pi-list',
              routerLink: '/pqi-hub/compliance-report',
            },
            {
              label: 'Risk Rating Report',
              icon: 'pi pi-fw pi-list',
              routerLink: '/pqi-hub/risk-rating-report',
            },
          ],
        },
        { separator: true },
        {
          label: '',
          icon: 'pi pi-fw pi-sign-out',
          command: () => this.logout(),
        },
      ];

      this.sfdcMenu = [
        {
          label: '',
          icon: 'pi pi-fw pi-th-large',
          routerLink: '/',
        },
        {
          label: 'Dashboard',
          icon: 'pi pi-fw pi-home',
          routerLink: 'pqi-hub/home',
        },
        {
          label: 'Signout',
          icon: 'pi pi-fw pi-sign-out',
          command: () => this.logout(),
        }
      ];
      this.vjMarketing = [
        {
          label: '',
          icon: 'pi pi-fw pi-th-large',
          routerLink: '/',
        },
        {
          label: 'VJ Offices',
          icon: 'fa fa-fw fa-plus',
          routerLink: '/vj-marketing/vj-offices',
        },
        {
          label: 'VJ Distributor',
          icon: 'fa fa-fw fa-plus',
          routerLink: '/vj-marketing/vj-distributor',
        },
        {
          label: 'Signout',
          icon: 'pi pi-fw pi-sign-out',
          command: () => this.logout(),
        }
      ];
      
    this.admin = [
      {
        label: '',
        icon: 'pi pi-fw pi-th-large',
        routerLink: '/',
      },
      {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-home',
        routerLink: 'pqi-admin/dashboard',
      },
      {
        label: 'User Management',
        icon: 'fa fa-fw fa-plus',
        routerLink: '/pqi-admin/user-management',  

      },
    ];
      
      this.handleRouteChange();
  }


  handleRouteChange = () => {
    if (this.router.url.includes('pqi-hub')) {
      
     this.tieredItems = this.hubMenu
    }else if(this.router.url.includes('pqi-jobs')  || this.router.url.includes('global')) {
      this.tieredItems = this.pidJobs
    }else if(this.router.url.includes('sfdc-sync')) {
      this.tieredItems = this.sfdcMenu
    }else if(this.router.url.includes('pqi-abr')) {
      this.tieredItems = this.ABRMenu
    }
    else if(this.router.url.includes('vj-marketing')) {
      this.tieredItems = this.vjMarketing
    }
    else if(this.router.url.includes('pqi-admin')) {
      this.tieredItems = this.admin
    }
    else{
      this.tieredItems =[];
    }
  };

  logout(){
    localStorage.clear();
    this.authenticationService.logout();
  }

  getJWTClaims(){
    this.authUserClaims = this.jwtHelper.decodeToken(this.authenticationService.accessToken);
  }

}
